import { send } from 'server';

export const getTopWinners = (params) => {
    const { startDate, endDate, casino, currency, topLength } = params;

    return send({
        ID: 35859,
        responses: [35860, 35861],
        description: 'Get top winners',
        startDate,
        endDate,
        casino,
        currency,
        topLength
    });
};
